<template>
    <div class="admin-index-container">
        <div class="vc-index-nav">
            <span><i class="fa fa-home margin-right-sm"></i>{{ $t('adminIndex.home') }}</span>
            <span class="margin-left-sm margin-right-sm">/</span>
            <span>{{ $t('adminIndex.platformData') }}</span>
        </div>
        <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3" class="margin-bottom" v-for="(item, index) in adminIndexInfo.datas" :key="index">
                <div class="white-bg text-center padding-top-sm ds-metric-card">
                    <div class="ds-metric-value" :style="{ 'color': item.color }">{{ item.value }}</div>
                    <div class="ds-metric-name">{{ item.name }}</div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xs="24" :lg="12">
                <div id="communityFeeCharts" style="height:400px;" class="bg-white padding"></div>
            </el-col>
            <el-col :xs="24" :lg="12">
                <div id="communityRepairCharts" style="height:400px;" class="bg-white padding"></div>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
import * as echarts from 'echarts'
import {
    queryAdminCount,
    queryCommunityFee,
    queryCommunityRepair
} from '@/api/user/adminIndexApi'
import { getDsChartPalette } from '@/utils/dsChartTheme'

export default {
    name: 'AdminIndex',
    data() {
        return {
            adminIndexInfo: {
                hostCount: 0,
                datas: [],
                action: ''
            },
            // 图表实例句柄，用于切换业态/重进页面时正确销毁
            communityFeeChart: null,
            communityRepairChart: null
        }
    },
    mounted() {
        this._loadViewAdminData()
        this._loadCommunityFee()
        this._loadCommunityRepair()
    },
    beforeDestroy() {
        // 释放 ECharts 实例，避免路由切换后内存泄漏（见 UI-REFACTOR-SPEC.md E1）
        if (this.communityFeeChart) {
            this.communityFeeChart.dispose()
            this.communityFeeChart = null
        }
        if (this.communityRepairChart) {
            this.communityRepairChart.dispose()
            this.communityRepairChart = null
        }
    },
    methods: {
        async _loadViewAdminData() {
            try {
                const res = await queryAdminCount({ platform: 'admin' })
                res.data.forEach((item, index) => {
                    // 使用统一图表色板，替代按索引硬编码的四色
                    item.color = getDsChartPalette()[index % 4]
                })
                this.adminIndexInfo.datas = res.data
            } catch (error) {
                console.error('Failed to load admin data:', error)
            }
        },
        async _loadCommunityFee() {
            try {
                const res = await queryCommunityFee({ platform: 'admin' })
                this._initAdminIndexCommunityFeeCharts(res.data)
            } catch (error) {
                console.error('Failed to load community fee data:', error)
            }
        },
        _initAdminIndexCommunityFeeCharts(_data) {
            const dom = document.getElementById('communityFeeCharts')
            const _source = [['product', this.$t('adminIndex.paymentCount'), this.$t('adminIndex.paymentAmount')]]

            _data.forEach(item => {
                _source.push([
                    item.communityName,
                    item.count,
                    item.receivedAmount
                ])
            })

            if (this.communityFeeChart) {
                this.communityFeeChart.dispose()
            }
            this.communityFeeChart = echarts.init(dom)
            const option = {
                legend: {},
                tooltip: {},
                title: {
                    show: true,
                    text: this.$t('adminIndex.communityFeeStats')
                },
                color: getDsChartPalette(),
                dataset: { source: _source },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [
                    { type: 'bar' },
                    { type: 'bar' }
                ]
            }

            if (option && typeof option === 'object') {
                this.communityFeeChart.setOption(option, true)
            }
        },
        async _loadCommunityRepair() {
            try {
                const res = await queryCommunityRepair({ platform: 'admin' })
                this._initAdminIndexCommunityRepairCharts(res.data)
            } catch (error) {
                console.error('Failed to load community repair data:', error)
            }
        },
        _initAdminIndexCommunityRepairCharts(_data) {
            const dom = document.getElementById('communityRepairCharts')
            const _source = [['product', this.$t('adminIndex.repairCount')]]

            _data.forEach(item => {
                _source.push([
                    item.communityName,
                    item.count
                ])
            })

            if (this.communityRepairChart) {
                this.communityRepairChart.dispose()
            }
            this.communityRepairChart = echarts.init(dom)
            const option = {
                legend: {},
                tooltip: {},
                title: {
                    show: true,
                    text: this.$t('adminIndex.communityRepairStats')
                },
                color: getDsChartPalette(),
                dataset: { source: _source },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [
                    { type: 'bar' }
                ]
            }

            if (option && typeof option === 'object') {
                this.communityRepairChart.setOption(option, true)
            }
        }
    }
}
</script>
  
<style lang="scss" scoped>
.admin-index-container {
  padding: 0 10px; // 添加左右内边距
}

.vc-index-nav {
    padding: 10px;
    font-size: 16px;
    text-align: left;
}

.margin-right-sm {
    margin-right: 5px;
}

.margin-left-sm {
    margin-left: 5px;
}

.margin-top-lg {
    margin-top: 15px;
}

.margin-bottom {
    margin-bottom: 20px;
}

.white-bg {
    background: #fff;
}

.text-center {
    text-align: center;
}

.padding-top-sm {
    padding-top: 10px;
}

.padding {
    padding: 15px;
}

.bg-white {
    background: #fff;
}

.ds-metric-card {
    background: #fff;
    border: 1px solid #e0e5eb;
    border-radius: 4px;
    padding: 20px 15px;
    min-height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
}

.ds-metric-value {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
    word-break: break-all;
    text-align: center;
    max-width: 100%;
    color: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ds-metric-name {
    font-size: 13px;
    font-weight: 400;
    color: #666;
    margin-top: 8px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}
</style>